import React, { FunctionComponent, Key } from 'react';
import { FormSelectWidgetProps, FormSelectWidget } from '@custis/common';

export const SingleSelect: FunctionComponent<FormSelectWidgetProps<Key>> = (props) => (
  <FormSelectWidget mode={'single'} {...props} />
);
export const MultipleSelect: FunctionComponent<FormSelectWidgetProps<Key>> = (props) => (
  <FormSelectWidget mode={'multiple'} {...props} />
);
